var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoginLogoResponsive = function SvgLoginLogoResponsive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 31,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M78.75 23.548v-4.29h3.295c2.422 0 4.383-1.92 4.383-4.29s-1.961-4.29-4.383-4.29h-4.383v8.58l-4.383 4.29H65.6v-4.29h7.679V6.371h8.782c4.845 0 8.783 3.855 8.783 8.597s-3.938 8.596-8.783 8.596zM64.48 8.516l-4.383 4.29v6.452H56.8V6.371H48.02c-4.845 0-8.783 3.855-8.783 8.597v8.596h7.662l4.416-4.29h-7.678v-4.322c0-2.371 1.96-4.29 4.383-4.29h4.383v12.886h7.678l4.4-4.29zM1.931 7.435l4.383 4.29h7.679v3.227H9.626c-4.844 0-8.782 3.855-8.782 8.596v2.146h4.383v-2.146c0-2.37 1.96-4.29 4.383-4.29h8.782v-7.532l-4.383-4.29zM37.045 19.258l-4.383 4.29H20.6V6.371l4.383-4.306v17.193zM62.288 6.371c1.22 0 2.192-.968 2.192-2.145 0-1.194-.989-2.145-2.192-2.145-1.22 0-2.191.967-2.191 2.145s.988 2.145 2.191 2.145M30.47 30c1.22 0 2.192-.968 2.192-2.145 0-1.194-.989-2.145-2.192-2.145-1.22 0-2.191.967-2.191 2.145S29.25 30 30.47 30M5.227 5.29c1.22 0 2.191-.967 2.191-2.145C7.418 1.952 6.43 1 5.227 1c-1.22 0-2.192.968-2.192 2.145S4.024 5.29 5.227 5.29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#loginLogoResponsive_svg__a)",
    d: "m136.257 31 6.902-6.89v-10.5c0-7.523-6.098-13.61-13.633-13.61h-18.429l-6.902 6.89h32.062z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#loginLogoResponsive_svg__b)",
    d: "M136.256 6.89A6.887 6.887 0 0 0 129.354 0h-11.116v6.89z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#loginLogoResponsive_svg__c)",
    d: "m101.746 0-6.902 6.89v10.5c0 7.523 6.097 13.61 13.633 13.61h18.428l6.902-6.89h-32.061z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#loginLogoResponsive_svg__d)",
    d: "M101.746 24.107a6.887 6.887 0 0 0 6.902 6.891h7.279v-6.89z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m121.918 14.584-4.675-2.701c-.72-.41-1.61.102-1.61.923v5.386c0 .82.89 1.334 1.61.924l4.675-2.668c.72-.41.72-1.453 0-1.864"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "loginLogoResponsive_svg__a",
    x1: 120.098,
    x2: 132.746,
    y1: 21.69,
    y2: -0.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#B21F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "loginLogoResponsive_svg__b",
    x1: 118.237,
    x2: 136.257,
    y1: 3.445,
    y2: 3.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C60000",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "maroon",
    stopOpacity: 0.397
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#490000",
    stopOpacity: 0.602
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#210000",
    stopOpacity: 0.776
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#090000",
    stopOpacity: 0.915
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "loginLogoResponsive_svg__c",
    x1: 105.232,
    x2: 117.88,
    y1: 31.238,
    y2: 9.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B21F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#FF6D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "#FF7E76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#FF9893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA29E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "loginLogoResponsive_svg__d",
    x1: 101.752,
    x2: 115.938,
    y1: 27.557,
    y2: 27.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#090000",
    stopOpacity: 0.915
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    stopColor: "#210000",
    stopOpacity: 0.776
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#490000",
    stopOpacity: 0.602
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    stopColor: "maroon",
    stopOpacity: 0.397
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#C60000",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red",
    stopOpacity: 0
  })))));
};
export default SvgLoginLogoResponsive;